export const AppBaseUrl = process.env.PUBLIC_URL || "";
export const isDevelopment = process.env.NODE_ENV === "development";
export const CompleteRedirectBaseUrl =
  process.env.REACT_APP_COMPLETE_REDIRECT_BASE;
export const BasePathname = "/value-my-vehicle";
